import React, {useEffect, useState} from 'react';
import FormHome from "../components/FormHome";
import EtapesProjet from "../components/EtapesProjet";
import {useParams, useLocation, useNavigate} from "react-router-dom";
import {API_URL} from "../config";

const Videos = () => {
    const {slug} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [projets, setProjets] = useState([]);

    // Récupère le dernier segment de l'URL si useParams ne marche pas
    const currentSlug = slug || location.pathname.split('/').filter(Boolean).pop();

    useEffect(() => {
        const fetchData = () => {
            fetch(`${API_URL}/videos/category/${currentSlug}?limit=2`)
                .then((res) => res.json())
                .then((data) => {
                    setProjets(data.videos || []);
                });
        };

        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [currentSlug]);


    return(
        <>
            <div className="pb-32 pt-64 videos vertical-section">
                <div className="grid grid-cols-2 gap-x-14 mx-32">
                    <div className="publicitaires">
                        <h1 className="text-title-xl">Vidéos évenementielles</h1>
                        <p>La vidéo événementielle est le meilleur moyen de capturer l’énergie, l’ambiance et les moments forts de vos événements.<br/><br/>
                            Chez Focus Production, entité du groupe Agence Le Menu, nous accompagnons les entreprises et les marques dans la réalisation de vidéos événementielles à Bordeaux et partout en France.<br/><br/>
                            Aftermovie, teaser, captation ou contenus réseaux sociaux : nous créons des formats dynamiques pensés pour prolonger l’expérience de votre événement et renforcer son impact.
                        </p>
                    </div>
                    <div className="publicitaires">
                        <div className="line"></div>
                        <p>Capturer l’instant, retranscrire l’émotion et faire vivre votre événement bien au-delà du jour J.
                        </p>
                    </div>
                </div>

                <div className="lesplus mx-32 mt-20 gap-x-20">
                    <div className="leplus-matos">
                        <h3>Des contenus qui engagent</h3>
                        <p>Chaque vidéo est pensée pour valoriser votre événement, engager votre audience et générer des contenus réutilisables sur vos différents supports de communication.</p>
                    </div>

                    <div className="leplus-plus">
                        <h3>Formats & Diffusion</h3>
                        <p>Nous utilisons des outils de production modernes pour vous permettre de diffuser rapidement des contenus impactants et adaptés aux nouveaux usages digitaux.</p>
                    </div>

                    <div className="leplus-bdx">
                        <h3>Réactivité et terrain</h3>
                        <p>Nos équipes s’adaptent à tous types d’événements : conférences, salons, lancements de produit, soirées ou événements internes. Grâce à une vraie expérience du terrain, nous capturons chaque moment avec fluidité et efficacité.</p>
                    </div>
                </div>

            </div>

            <EtapesProjet/>

            <div className="autres px-32 py-16">
                <h2 className="font-bold text-f-40">Quelques réalisations<span>.</span></h2>
                <div className="autres-videos mt-8">
                    <div className="autres-videos-api">
                        {projets.map((projet) => (
                            <div className="card" key={projet.id}>
                                {projet.thumbnail ? (
                                    <img alt={projet.title} src={`${projet.thumbnail}`}/>
                                ) : (
                                    <div className="card-no-thumb">Pas d'aperçu</div>
                                )}
                                <h3 className="mt-2">{projet.title}</h3>
                                <p>{projet.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="autres-videos-bloc">
                        <p>Envie d'en voir plus ? </p>
                        <a onClick={() => navigate(`/realisations?cat=${currentSlug}`)} style={{cursor: 'pointer'}}>
                            Voir les réalisations</a>
                    </div>


                </div>
            </div>

            <FormHome/>


    </>

    )
}

export default Videos